// @ts-check
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SelectV2 from 'components/Select/SelectV2';
/**
 * @typedef RelationshipOption
 * @prop {string} id
 * @prop {string} label
 */

/**
 * @typedef RelationDropdownProps
 * @prop {RelationshipOption[]} relationsMap an array of objects with id and label properties
 * @prop {string | string[]} relation the selected relation(s)
 * @prop {function(string|string[]): void | React.Dispatch<React.SetStateAction<string|string[]>>} onRelationChanged callback for when the relation(s) is changed
 * @prop {boolean} [isMultiple=false] if true, the dropdown will allow multiple selections
 * @prop {string} [placeholder] the placeholder text for the dropdown
 * @prop {boolean} [isDisabled=false] if true, the dropdown will be disabled
 */

/**
 * @description Select one or more relations from a dropdown
 * @component
 * @param {RelationDropdownProps} props
 * @returns {JSX.Element}
 */
const RelationDropdown = ({ relationsMap, relation, onRelationChanged, isMultiple, placeholder, isDisabled }) => {

  const options = useMemo(() => {
    return relationsMap.map(radio => ({
      id: radio.id,
      value: radio.id,
      text: radio.label
    }));
  }, [relationsMap]);

  return (
    <SelectV2
      value={relation}
      options={options}
      onChange={onRelationChanged}
      isMultiple={isMultiple}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  );
};

RelationDropdown.propTypes = {
  relationsMap: PropTypes.array,
  relation: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onRelationChanged: PropTypes.func,
  isMultiple: PropTypes.bool,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default RelationDropdown;
